import React, { memo, forwardRef } from "react";
const SvgImplies = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M6 12a1 1 0 100 2h16a1 1 0 100-2H6zm0 6a1 1 0 100 2h16a1 1 0 100-2H6z"
        clipRule="evenodd"
      />
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M20 9c0 5 8 7 8 7s-8 2-8 7"
      />
    </svg>
  );
});
SvgImplies.displayName = "SvgImplies";
const MemoForwardRef = memo(SvgImplies);
export default MemoForwardRef;
